// Dependencies
import React from "react";

// Modules

// App
import { apiEndpoints } from "../../config";


import PostEdit from "../../partials/posts/postEdit";

export default function NewsEdit() {
  //   const extraFields = useMemo(() => ({}), []);

  return (
    <PostEdit
      entityType={"news"}
      apiEndpoint={apiEndpoints.news}
      screenClassName={"news"}
      categoryTitle={"News category"}
      categoryName={"field_news_category"}
      targetVid={"news_categories"}
      returnRoute={"/news-creator"}
      backBtnText={"News Library"}
      previewRoute={"/news/preview"}
      logCustomEventType={"News"}
      featuredImageEnabled={true}
      editorProps={{
        title: true,
        subtitle: true,
        body: true,
        list: true,
        table: true,
        image: true,
        video: true,
        embed: true,
        rule: true,
        buttonGroup: true,
        chart: true,
        map: true,
      }}
      imageBlockEnabled={true}
    ></PostEdit>
  );
}
